module.exports = __webpack_public_path__ + "static/av_logo_white-a7c307c8b176e8915b02d0d23bb64ef1.png";